import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ReportsLibrary } from './components/ReportsLibrary';
import { PortfolioView } from './components/PortfolioView';

export default function TumReportsExports() {
  const [activeTab, setActiveTab] = useState('reports-library');

  return (
    <div className="container mx-auto p-6 space-y-6">
      {/* Header */}
      <div className="space-y-2">
        <h1 className="text-4xl font-bold tracking-tight">Reports & Exports</h1>
        <p className="text-muted-foreground mt-2 text-lg">
          Access standard reports, create custom portfolio views, and schedule exports
        </p>
      </div>

      {/* Main Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <div className="border-b border-border">
          <TabsList className="w-full h-auto p-0 bg-transparent justify-start overflow-x-auto flex-nowrap gap-1">
            <TabsTrigger
              value="reports-library"
              className="flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-t-lg border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-background data-[state=active]:shadow-sm transition-all whitespace-nowrap"
            >
              Reports Library
            </TabsTrigger>
            <TabsTrigger
              value="portfolio-view"
              className="flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-t-lg border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-background data-[state=active]:shadow-sm transition-all whitespace-nowrap"
            >
              Portfolio View
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="reports-library" className="mt-6">
          <ReportsLibrary />
        </TabsContent>

        <TabsContent value="portfolio-view" className="mt-6">
          <PortfolioView />
        </TabsContent>
      </Tabs>
    </div>
  );
}

